<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Login</h4>
                                    <p>Welcome back, please login to your account.</p>
                                </div>
                                <vs-input
                                    v-validate="'required|email|min:3'"
                                    data-vv-validate-on="blur"
                                    name="email"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="Email"
                                    v-model="email"
                                    class="w-full no-icon-border"/>
                                <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                                <vs-input
                                    data-vv-validate-on="blur"
                                    v-validate="'required|min:6|max:50'"
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="Password"
                                    v-model="password"
                                    class="w-full mt-6 no-icon-border" />
                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                <div class="flex flex-wrap justify-between my-5">
                                    <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
                                    <router-link to="/pages/forgot-password">Forgot Password?</router-link>
                                </div>

                                <vs-button type="border" :disabled="!validateForm" @click="login">Login</vs-button>                       
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import AccessControlService from '../../services/AccessControlService';

export default {
    data() {
        return {
            email: '',
            password: '',
            checkbox_remember_me: false
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.email != '' && this.password != '';
        },
    },
    methods: {
        async login() {
            try {
                this.$vs.loading()

                const payload = {
                    checkbox_remember_me: this.checkbox_remember_me,
                    userDetails: {
                        email: this.email,
                        password: this.password
                    },
                    notify: this.$vs.notify,
                    closeAnimation: this.$vs.loading.close,
                    errors: this.errors
                }

                await AccessControlService.login(payload);
                AccessControlService.getUserInfo();

                this.$vs.loading.close();
                this.$router.push('/');
            } catch (error) {
                await this.handleError(error);
            }
        },

        async openAlert(color, title, message) {
            this.$vs.dialog({
                color: color,
                title: title,
                text: message
            })
        },

        async handleError(error) {
            if(error.status == 500) {
                await this.openAlert("danger", "Error", "Tente novamente mais tarde.");
            } else if(error.status > 400) {
                await this.openAlert("danger", "Error", error.data.error_description);
            }

            this.$vs.loading.close();
        },

        notifyAlreadyLogedIn() {
            this.$vs.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
        },

        registerUser() {
            if(this.$store.state.auth.isUserLoggedIn()) {
                this.notifyAlreadyLogedIn();
                return false;
            }
            this.$router.push('/pages/register');
        },
        async created() {
          try {
            const response = await axios.get(`http://jsonplaceholder.typicode.com/posts`);
            this.posts = response.data;
          } catch (e) {
            this.errors.push(e)
          }
    }
  }
}
</script>